import React from "react";
import ReusableDemoPage from "../ReusableDemoPage";
import { haflaConfig } from "../demoConfigs";

const HaflaDemo = () => {
  return <ReusableDemoPage config={haflaConfig} />;
};

export default HaflaDemo;

